.container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
  min-width: 0;
}

.topSummaryCard {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-lg);
  padding: 1.2rem 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: var(--shadow-card);
}

.topHeaderRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.9rem;
  flex-wrap: wrap;
}

.eyebrow {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #006a61;
  display: block;
  margin-bottom: 0.2rem;
}

.title {
  font-family: var(--font-display);
  font-variant-numeric: tabular-nums;
  font-size: 1.15rem;
  font-weight: 800;
  color: #0d1c2e;
  margin: 0;
}

.subtitle {
  font-size: 0.8rem;
  color: #444651;
  margin: 0.2rem 0 0 0;
  line-height: 1.4;
}

.switchViewBtn {
  padding: 0.56rem 0.95rem;
  min-height: 42px;
  border-radius: var(--radius-sm);
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
}

.switchViewBtn:hover {
  background: #dce9ff;
}

.kpiStrip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem;
}

.kpiBox {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 0.85rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
  font-variant-numeric: tabular-nums;
}

.kpiLabel {
  font-size: 0.69rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #444651;
}

.kpiValue {
  font-family: var(--font-display);
  font-variant-numeric: tabular-nums;
  font-size: 1.24rem;
  font-weight: 800;
  color: #00236f;
}

.kpiHint {
  font-size: 0.73rem;
  color: #444651;
}

.monthNavigatorBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 0.75rem 0.95rem;
}

.monthNavControls {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.monthStepBtn {
  min-height: 40px;
  padding: 0.42rem 0.75rem;
  border-radius: var(--radius-sm);
  border: 1px solid #d5e3fc;
  background: #ffffff;
  color: #00236f;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
}

.monthStepBtn:hover {
  border-color: #00236f;
  background: #dce9ff;
}

.monthInput {
  min-height: 40px;
  background: #ffffff;
  border: 1px solid #c5c5d3;
  border-radius: 10px;
  padding: 0.42rem 0.7rem;
  font-family: var(--font-display);
  font-variant-numeric: tabular-nums;
  font-size: 0.84rem;
  font-weight: 800;
  color: #00236f;
}

.mainGrid {
  display: grid;
  grid-template-columns: 420px minmax(0, 1fr);
  gap: 1.25rem;
  align-items: start;
  min-width: 0;
}

.card {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-lg);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: var(--shadow-card);
  min-width: 0;
}

.cardTitle {
  font-family: var(--font-display);
  font-size: 1.02rem;
  font-weight: 800;
  color: #0d1c2e;
}

.cardSub {
  font-size: 0.78rem;
  color: #444651;
}

.formStack {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.fieldRow {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.72rem;
}

.fieldRowThree {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.7rem;
}

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
}

.label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #444651;
}

.input,
.select {
  width: 100%;
  min-height: 42px;
  background: #ffffff;
  border: 1px solid #c5c5d3;
  color: #0d1c2e;
  border-radius: 10px;
  padding: 0.55rem 0.72rem;
  font-size: 0.84rem;
  outline: none;
  font-variant-numeric: tabular-nums;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input:focus,
.select:focus {
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.12);
}

.inevitableCheckboxBox {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-sm);
  padding: 0.75rem 0.85rem;
  cursor: pointer;
}

.inevitableCheckboxInput {
  margin-top: 0.18rem;
  width: 18px;
  height: 18px;
  accent-color: #00236f;
  flex-shrink: 0;
  cursor: pointer;
}

.primaryBtn {
  padding: 0.68rem 1rem;
  min-height: 42px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  border: 1px solid #00236f;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.18);
  font-weight: 700;
  font-size: 0.84rem;
  cursor: pointer;
  transition: box-shadow 0.15s ease;
}

.primaryBtn:hover {
  box-shadow: 0 6px 16px rgba(0, 35, 111, 0.25);
}

.secondaryBtn {
  padding: 0.48rem 0.78rem;
  min-height: 38px;
  border-radius: var(--radius-sm);
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  font-weight: 700;
  font-size: 0.76rem;
  cursor: pointer;
}

.neutralBtn {
  padding: 0.45rem 0.75rem;
  min-height: 38px;
  border-radius: var(--radius-sm);
  border: 1px solid #c5c5d3;
  background: #ffffff;
  color: #0d1c2e;
  font-weight: 600;
  font-size: 0.75rem;
  cursor: pointer;
}

.dangerBtn {
  padding: 0.45rem 0.75rem;
  min-height: 38px;
  border-radius: var(--radius-sm);
  background: #ffdad6;
  border: 1px solid rgba(186, 26, 26, 0.28);
  color: #93000a;
  font-weight: 700;
  font-size: 0.75rem;
  cursor: pointer;
}

.rulesList {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.ruleCard {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-variant-numeric: tabular-nums;
}

.ruleCardPaused {
  opacity: 0.72;
  border-style: dashed;
}

.ruleHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
  flex-wrap: wrap;
}

.ruleTitle {
  font-family: var(--font-display);
  font-size: 0.94rem;
  font-weight: 700;
  color: #0d1c2e;
}

.ruleMeta {
  font-size: 0.75rem;
  color: #444651;
  line-height: 1.4;
}

.badgesRow {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
  margin-top: 0.3rem;
}

.inevitableToggleBtn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.71rem;
  font-weight: 700;
  padding: 0.25rem 0.6rem;
  border-radius: 6px;
  cursor: pointer;
}

.inevitableActive {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  color: #92400e;
}

.inevitableControllable {
  background: rgba(134, 242, 228, 0.35);
  border: 1px solid rgba(0, 106, 97, 0.35);
  color: #005049;
}

.overrideBadge {
  display: inline-block;
  font-family: var(--font-mono);
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.16rem 0.5rem;
  border-radius: 5px;
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #f59e0b;
}

.baseBadge {
  display: inline-block;
  font-family: var(--font-mono);
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.16rem 0.5rem;
  border-radius: 5px;
  background: #dce9ff;
  color: #00236f;
}

.pausedBadge {
  display: inline-block;
  font-family: var(--font-mono);
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.16rem 0.5rem;
  border-radius: 5px;
  background: #e2e8f0;
  color: #475569;
}

.amountDisplay {
  font-family: var(--font-display);
  font-variant-numeric: tabular-nums;
  font-size: 1.1rem;
  font-weight: 800;
  color: #ba1a1a;
  display: block;
}

.monthEditorRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  flex-wrap: wrap;
  padding-top: 0.6rem;
  border-top: 1px dashed #c5c5d3;
}

.monthEditorControls {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.ruleActionsFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding-top: 0.5rem;
  border-top: 1px solid #dce9ff;
}

.fullEditBox {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-sm);
  padding: 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.emptyStateBox {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 1.4rem;
  text-align: center;
  font-size: 0.82rem;
  color: #444651;
}

@media (max-width: 980px) {
  .mainGrid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 640px) {
  .kpiStrip,
  .fieldRow,
  .fieldRowThree {
    grid-template-columns: minmax(0, 1fr);
  }

  .topSummaryCard,
  .card {
    padding: 0.95rem;
  }

  .switchViewBtn {
    width: 100%;
    text-align: center;
  }

  .monthEditorControls {
    width: 100%;
  }
}
